var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home-hero",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":"","column":"","pa-5":""}},[_c('div',{staticClass:"font-weight-black blue--text text--darken-2 text-center",class:{
        'display-1': _vm.$vuetify.breakpoint.xs,
        'display-2': _vm.$vuetify.breakpoint.sm,
        'display-3':
          _vm.$vuetify.breakpoint.md ||
          _vm.$vuetify.breakpoint.lg ||
          _vm.$vuetify.breakpoint.xl
      }},[_c('p',{staticClass:"orange--text"},[_vm._v("404")]),_c('p',[_vm._v("Page not found")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }